import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { PithLogo } from '@/components/brand';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle: string;
  footer?: ReactNode;
}

export function AuthLayout({ children, title, subtitle, footer }: AuthLayoutProps) {
  return (
    <div className="auth-layout flex min-h-screen flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-[400px] space-y-8">
        {/* Logo/Brand */}
        <div className="text-center">
          <Link to="/" className="inline-block">
            <PithLogo size="xl" className="auth-logo" />
          </Link>
        </div>

        {/* Title */}
        <div className="text-center">
          <h1 className="font-serif text-3xl font-bold tracking-tight text-primary">{title}</h1>
          <p className="auth-subtitle mt-3 font-sans text-sm">{subtitle}</p>
        </div>

        {/* Content */}
        <div className="auth-card rounded-sm p-8">{children}</div>

        {/* Footer */}
        {footer && <div className="auth-footer text-center font-sans text-sm">{footer}</div>}
      </div>
    </div>
  );
}
